import { Fragment, useState, useRef, useEffect } from 'react';
import { Nav, NavbarBrand, NavItem } from 'reactstrap';

import { useAuth } from '../../providers/AuthProvider';
import { EMPTY_STRING, LOGIN_N, NEW_COLLECTION_N, NEW_COLLECTION_PATH } from '../../constants';
import Cureyta from "../../imgs/Cureyta.svg";
import Logo from "../../imgs/logo-big.svg";
import Avatar from "../../imgs/avatar.jpg";
import { AccountsImg, ButtonLabel, ButtonP, LogoImg, LogoNameImg, Navbar, DropdownDiv, StackDivCol, Text } from '../../styles/styles';

const useOutsideClick = (ref: any, showDropdown: any) => {
  useEffect(() => {
    function handleClickOutside(event: any) {
      if (ref.current && !ref.current.contains(event.target) && event.target.id !== "img") {
        showDropdown(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, showDropdown]);
}

const MainNavbar = () => {
  const { currentUser, signOut } = useAuth();
  const [showDropdown, setShowDropdown] = useState(false);
  const wrapperRef = useRef(null);
  useOutsideClick(wrapperRef, setShowDropdown);

  const handleNewCollectionClick = () => {
    window.location.assign(NEW_COLLECTION_PATH);
  }

  const getNameOrEmail = () => {
    if (currentUser?.displayName) {
      return currentUser?.displayName;
    }
    return currentUser?.email;
  }

  const getUserPhoto = () => {
    if (currentUser && currentUser?.photoURL && currentUser?.photoURL !== EMPTY_STRING) {
      return currentUser?.photoURL;
    }
    return Avatar;
  }

  const determineButtonText = () => {
    if (currentUser) {
      return NEW_COLLECTION_N;
    }
    return LOGIN_N;
  }

  return (
    <>
      <Navbar light expand="md">
        <NavbarBrand href="/">
          <Fragment>
            <LogoImg src={Logo} />
            <LogoNameImg src={Cureyta} />
          </Fragment>
        </NavbarBrand>
        <Nav style={{ alignItems: "center", gap: "10px" }} navbar>
          <NavItem>
            <ButtonLabel onClick={handleNewCollectionClick}>{determineButtonText()}</ButtonLabel>
          </NavItem>
          {currentUser &&
            <NavItem>
              <AccountsImg id="img" src={getUserPhoto()} style={{ marginRight: "0px" }} onClick={() => setShowDropdown(!showDropdown)} />
              {showDropdown && (
                <DropdownDiv ref={wrapperRef}>
                  <StackDivCol>
                    <Text>{getNameOrEmail()}</Text>
                    <ButtonP onClick={signOut} style={{ marginLeft: "2px", marginBottom: "7px" }}>Sign out</ButtonP>
                  </StackDivCol>
                </DropdownDiv>
              )
            }
            </NavItem>
          }
        </Nav>
      </Navbar>
    </>
  )
};

export default MainNavbar;
